import { KnownBannerId, useAddKnownBannerCallback, } from '@office-start/banner-service';
import { initEdgeworthDb, setDbStates, useMutateEdgeworthItem, useSingletonEdgeworthDocuments, useSingletonEdgeworthTags, } from '@office-start/edgeworth-service';
import { useEdgeworthTrie } from '@office-start/edgeworth-trie-service';
import { useEffect, useMemo, useRef } from 'react';
import { useEdgeworthCallbacks } from './useEdgeworthCallbacks';
export function useEdgeworthDataPrep(_a) {
    var instrumentationArea = _a.instrumentationArea, bridgeData = _a.bridgeData, context = _a.context, locStrings = _a.locStrings, identity = _a.identity, filterFileType = _a.filterFileType;
    var onBlocking = useAddKnownBannerCallback(KnownBannerId.SessionExpired);
    var isDbInitializedRef = useRef(false);
    if (!isDbInitializedRef.current && identity && context) {
        if (bridgeData &&
            bridgeData.databasePuid === identity.puid &&
            bridgeData.database) {
            // If database is passed in as part of bridgeData and puid hasn't changed, we set the database
            // instead of initializing
            setDbStates({
                database: bridgeData.database,
                puid: identity.puid,
                workload: context.workload,
            });
        }
        else {
            initEdgeworthDb(identity.puid, context.workload, (bridgeData === null || bridgeData === void 0 ? void 0 : bridgeData.databaseVersionOffset) || 1, onBlocking);
        }
        isDbInitializedRef.current = true;
    }
    // Wrapping bridge data behind condition so we only pass the cached data if puids match
    var wrappedBridgeData = identity && bridgeData && identity.puid === bridgeData.databasePuid
        ? bridgeData
        : undefined;
    var _b = useSingletonEdgeworthDocuments(filterFileType, wrappedBridgeData === null || wrappedBridgeData === void 0 ? void 0 : wrappedBridgeData.preloadedCacheEntries), documents = _b.documents, isError = _b.isError, isInitialStable = _b.isInitialStable, msaUserHint = _b.msaUserHint, resync = _b.resync;
    var _c = useMutateEdgeworthItem(), pinMutation = _c.pinMutation, hideMutation = _c.hideMutation;
    var _d = useEdgeworthTrie(), addToTrie = _d.addToTrie, queryTrie = _d.queryTrie;
    var tags = useSingletonEdgeworthTags();
    var callbacks = useEdgeworthCallbacks({
        resync: resync,
        queryTrie: queryTrie,
        pinMutation: pinMutation,
        hideMutation: hideMutation,
        locStrings: locStrings,
        instrumentationArea: instrumentationArea,
        tags: tags,
    });
    useEffect(function () {
        if (documents.length) {
            addToTrie(documents);
        }
    }, [addToTrie, documents]);
    return useMemo(function () { return ({
        documents: documents,
        isError: isError,
        isInitialStable: isInitialStable,
        callbacks: callbacks,
        resync: resync,
        tags: tags,
        msaUserHint: msaUserHint,
    }); }, [
        documents,
        isError,
        isInitialStable,
        callbacks,
        resync,
        tags,
        msaUserHint,
    ]);
}
//# sourceMappingURL=useEdgeworthDataPrep.js.map